import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/core/http/web/home.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  public route: string;
  public orden: any = null;
  public objectValues = Object.values;
  public loadings: any = true;
  public errors: any = null;
  public loadPerParts: boolean;
  public dataServ: any;
  constructor(
    private titleService: Title,
    private _route: Router,
    private homeWpServ: HomeService
  ) {
    this.titleService.setTitle('Mundo Joven 2019');
    this.route = _route.url.slice(1);
    this.route = this.route.split('?')[0];
    console.log('La ruta es: ', this.route);
    this.getAllData(this.route);
  }

  getAllData(ruta) {
    this.homeWpServ.getAllDataPage(ruta).subscribe(data => {
      console.log('Datos de la página: ', data);
      // this.orden = data.ordenamiento;
      this.dataServ = data;
      this.loadings = false;
    }, err => {
      console.error('Error | el servicio retorno un error:', err);
      this.errors = err;
      this.loadPerParts = true;
      this.dataServ = {};
    });
  }
  reload() {
    this.loadings = true;
    this.getAllData(this.route);
  }
}
